import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { spacing, breakpoints, colors, fonts, fontSize, radius, sizes } = redesignTheme;

export const useRecrutementFormStyles = makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.sm,
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  select: {
    width: '100%',
    height: sizes.inputHeight,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: '0 12px',
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    outline: 'none',
    boxSizing: 'border-box',
    appearance: 'none',
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23383838' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    paddingRight: 36,
    cursor: 'pointer',
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  placesField: {
    width: '100%',
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiOutlinedInput-root': {
      height: sizes.inputHeight,
      minHeight: sizes.inputHeight,
      borderRadius: radius.sm,
      fontFamily: fonts.opensans,
      fontSize: fontSize.base,
      backgroundColor: colors.white,
      alignItems: 'center',
      flexWrap: 'nowrap',
      padding: '0 !important',
    },
    '& .MuiOutlinedInput-input': {
      padding: '0 12px',
      height: sizes.inputHeight,
      boxSizing: 'border-box',
      lineHeight: `${sizes.inputHeight}px`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.border,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.border,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.primary,
    },
  },
  submitButton: {
    ...primaryButtonStyle,
    marginTop: spacing.xs,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: colors.primaryDark,
      opacity: 0.92,
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: colors.primaryDark,
      color: colors.white,
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
}));
